import clsx from "clsx";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import "./styles.scss";
import {} from "halifax/src/AmenityIcon/resources";
import {
  RoomInfoProducts,
  RoomPaymentSchedule,
} from "redmond/hotels-module/interfaces";
import {
  ActionButton,
  ActionLink,
  CloseButtonIcon,
  DesktopPopupModal,
  MobilePopoverCard,
} from "halifax";
import React, { useState } from "react";
import {
  CONTINUE,
  PAY_LATER_LABEL,
  PAY_LATER_NOTES,
  PAY_NOW_LABEL,
  READ_TERMS_AND_CONDITIONS,
  SELECT_WHEN_TO_PAY,
  SUBTITLE,
} from "./constants";
import { HotelRoomPaymentScheduleModalConnectorProps } from "./container";

export interface IHotelRoomPaymentScheduleModalProps
  extends HotelRoomPaymentScheduleModalConnectorProps {
  openModal: boolean;
  onClose: () => void;
  onClickContinue: (selectedProductIndex: number) => void;
  roomInfoProducts: RoomInfoProducts;
  isMobile?: boolean;
}
export const HotelRoomPaymentScheduleModal = (
  props: IHotelRoomPaymentScheduleModalProps
) => {
  const {
    openModal,
    onClose,
    isMobile,
    roomInfoProducts,
    onClickContinue,
    selectedAccount,
    shopSelectedProductIndex,
  } = props;

  const [modalSelectedProductIndex, setModalSelectedProductIndex] = useState(
    shopSelectedProductIndex ?? 0
  );

  const renderRadioLabel = (
    paymentSchedule: RoomPaymentSchedule | undefined
  ) => {
    const paymentCardType = selectedAccount?.productDisplayName ?? "";
    switch (paymentSchedule) {
      case RoomPaymentSchedule.PayNow:
        return (
          <span className="payment-schedule-option-label">
            {PAY_NOW_LABEL(paymentCardType)}
          </span>
        );
      case RoomPaymentSchedule.PayLater:
        return (
          <>
            <span className="payment-schedule-option-label">
              {PAY_LATER_LABEL(paymentCardType)}
            </span>
            <span className="paylater-notes">{PAY_LATER_NOTES}</span>
          </>
        );
      default:
        throw new Error(`Unsupported payment schedule: ${paymentSchedule}`);
    }
  };

  const renderRadios = () =>
    roomInfoProducts.products.map((product, index) => (
      <FormControlLabel
        className="payment-schedule-option"
        key={`${index.toString()}`}
        value={index}
        checked={modalSelectedProductIndex === index}
        label={renderRadioLabel(product.roomPaymentSchedule)}
        labelPlacement="end"
        control={<Radio className="radio" role="radio" />}
      />
    ));

  const renderModalContent = () => (
    <>
      <Box className="header">
        <Typography variant="h6" className="title">
          {SELECT_WHEN_TO_PAY}
        </Typography>
      </Box>
      <Box className="top-content">
        <Box className="subtitle">{SUBTITLE}</Box>
        <ActionLink
          // TBD CLUX-662
          content={
            <Typography className="terms-and-conditions" variant="body1">
              <span>{READ_TERMS_AND_CONDITIONS}</span>
            </Typography>
          }
        />
      </Box>
      <Box className="body-content">
        <RadioGroup
          className="radios"
          onChange={(e) => {
            setModalSelectedProductIndex(Number(e.target.value));
          }}
          aria-label="Payment schedule options"
        >
          {renderRadios()}
        </RadioGroup>
      </Box>
      <Box className="bottom-content">
        <ActionButton
          message={CONTINUE}
          onClick={() => {
            onClickContinue(modalSelectedProductIndex);
          }}
          defaultStyle="h4r-primary"
        />
      </Box>
    </>
  );
  return (
    <>
      {isMobile && (
        <MobilePopoverCard
          className={clsx("hotel-room-payment-schedule-modal", "mobile")}
          open={openModal}
          topRightButton={
            <ActionLink
              className="close-button"
              content={<CloseButtonIcon />}
              label="Close"
              onClick={onClose}
            />
          }
          onClose={onClose}
        >
          {renderModalContent()}
        </MobilePopoverCard>
      )}
      {!isMobile && (
        <DesktopPopupModal
          open={openModal}
          onClose={onClose}
          className="hotel-room-payment-schedule-modal"
          invisibleBackdrop={false}
        >
          {renderModalContent()}
        </DesktopPopupModal>
      )}
    </>
  );
};
